import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChartConfiguration, ChartData } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

// Material Imports
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import { Conversation } from '../../../services/conversation';

@Component({
  selector: 'app-cross-tab',
  standalone: true,
  imports: [
    CommonModule, FormsModule, BaseChartDirective, MatFormFieldModule,
    MatInputModule, MatDatepickerModule, MatButtonModule, 
    MatTableModule, MatCardModule, MatIconModule
  ],
  templateUrl: './cross-tab.component.html',
  styleUrls: ['./cross-tab.component.scss']
})
export class CrossTabComponent implements OnInit {

  @Input() globalStartDate!: Date;
 @Input() globalEndDate!: Date;

  crossTabData: any[] = [];
   startDate = new Date();
   endDate = new Date();

  // Chart Configuration
  stackedBarData: ChartData<'bar'> = { labels: [], datasets: [] };
  stackedBarOptions: ChartConfiguration<'bar'>['options'] = {
    indexAxis: 'y', // Makes it a horizontal bar chart
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { stacked: true, title: { display: true, text: 'Total Interactions' } },
      y: { stacked: true }
    },
    plugins: {
      legend: { position: 'top' }
    }
  };

  constructor(private conversationService: Conversation) {
    this.startDate.setDate(this.endDate.getDate() - 30);
  }

  ngOnInit(): void {
    this.fetchCrossTab();
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['globalStartDate'] || changes['globalEndDate']) {
    this.startDate = this.globalStartDate;
    this.endDate = this.globalEndDate;
    this.fetchCrossTab(); // Your existing fetch/load function
  }
}

  fetchCrossTab(): void {
    const start = this.startDate.toISOString().split('T')[0];
    const end = this.endDate.toISOString().split('T')[0];

    this.conversationService.getCrossTab(start, end).subscribe(res => {
      const data = res.data ?? [];
      this.crossTabData = data;

      this.stackedBarData = {
        labels: data.map((d: any) => d.conversation_category),
        datasets: [
          {
            label: 'Satisfied',
            data: data.map((d: any) => d.Satisfied),
            backgroundColor: '#10b981' // Green
          },
          {
            label: 'Indifferent',
            data: data.map((d: any) => d.Indifferent),
            backgroundColor: '#f59e0b' // Amber
          },
          {
            label: 'Not Satisfied',
            data: data.map((d: any) => d.Not_Satisfied),
            backgroundColor: '#ef4444' // Red
          }
        ]
      };
    });
  }

  downloadCSV(): void {
    const headers = ['Category', 'Satisfied', 'Indifferent', 'Not_Satisfied'];
    const csvContent = [
      headers.join(','),
      ...this.crossTabData.map(row => 
        `${row.conversation_category},${row.Satisfied},${row.Indifferent},${row.Not_Satisfied}`
      )
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `category_outcome_cross_tab.csv`;
    a.click();
  }
}